import React, { useEffect, useState } from 'react';
import { useDictionary } from '../../../../utilities/hooks/UseDictionary';
import dots from '../../../../assets/icons/ic_three_dots.svg';
// a
import check from '../../../../assets/icons/ic_check.svg';
import { ReactComponent as EyeIcon } from '../../../../assets/icons/ic_eye.svg';
import { ReactComponent as RoundedCloseIcon } from '../../../../assets/icons/ic_close_round.svg';
import { ReactComponent as CloseIcon } from '../../../../assets/icons/ic_close.svg';
import { ReactComponent as ClockIcon } from '../../../../assets/icons/ic_clock.svg';
import { ReactComponent as PencilIcon } from '../../../../assets/icons/ic_pencil.svg';
import { ReactComponent as TrashIcon } from '../../../../assets/icons/ic_trash.svg';

import useComponentVisible from '../../../../utilities/hooks/useComponentVisible';
import { useBookingStatuses } from '../../../../utilities/hooks/useBookingStatuses';
import { UseCurrencyDecorator } from '../../../../utilities/hooks/UseCurrencyDecorator';
import PropTypes from 'prop-types';
import {DateFormatHelper} from "../../../../utilities/helpers/DateFormatHelper";
import IconButton from '../atom/IconButton.js';
import moment from 'moment';
import PaymentStatusListItem from "../../common/status-label/PaymentStatusListItem";
import { AmountFormatHelper } from '../../../../utilities/helpers/AmountFormatHelper.js';
import ProfileImage from '../../common/ProfileImage.js';
import ChannelIcon from '../../common/ChannelIcon';

// eslint-disable-next-line no-unused-vars
const BookingItem = ({ columns,item, onDeleteClicked, onBookingClicked, onCancelClicked, onEditClicked }) => {
	const dictionary = useDictionary();

	// Only offline-accepted bookings can be edited / hard-deleted by the
	// provider — the same rule the booking detail page applies.
	const isOffline =
		item.accepted_as_offline === true ||
		item.accepted_as_offline === 1 ||
		item.accepted_as_offline === '1';

	const { ref, isComponentVisible, setIsComponentVisible } =
		useComponentVisible(false);
	const [showStatuses, setStatusesVisibility] = useState(false);

	const currencyDecorator = UseCurrencyDecorator();

	useEffect(() => {
		if (!isComponentVisible) {
			setStatusesVisibility(false);
		}
	}, [isComponentVisible]);

	const bookingStatuses = useBookingStatuses();
	const getBookingStatus = (status) => {
		return (
			<div className={'booking-status ' + bookingStatuses[status]?.class}>
				{bookingStatuses[status]?.text}
			</div>
		);
	};

	const changeBookingStatusAsync = async (e) => {
		e.stopPropagation();
	};

	const onContextClicked = () => {
		setIsComponentVisible(!isComponentVisible);
	};

	return (
		<tr
			data-testid={'booking-item'}
			style={{ cursor: 'pointer' }}
			onClick={() => onBookingClicked(item)}
		>
			{columns["#"]?.visible && (
			<td className="booking-index">
				<div className="booking-number" data-testid="booking-number">
					{item.display_id}
				</div>
			</td>
			)}
			{columns[dictionary.create_date]?.visible && (
			<td data-testid="booking-date">
				{DateFormatHelper.monthYearTimeFormat(item.created_at)}
			</td>
			)}
			{columns[dictionary.status]?.visible && (
				<td data-testid="booking-status">
					{getBookingStatus(item.status.value)}
				</td>
			)}
			{columns[dictionary.customer]?.visible && (
				<td>
					<div
						className="booking-customer-container"
						data-testid="booking-customer-container"
						style={{gap: '8px'}}
					>
					<ProfileImage name={item.customer.name} photo={item.customer.avatar_url} size={{ width: 24, height: 24,fontSize: 11, lineHeight: 14 }}/>
					<div data-testid="booking-customer-name" className='truncate admin-booking-customer-name' title={item.customer.name}>{item.customer.name}</div>
					</div>
				</td>
			)}
			{columns[dictionary.Spots]?.visible && (
				<td>
					<span>{item.participants_quantity}</span>
				</td>
			)}
			{columns[dictionary.channel]?.visible && (
				<td data-testid="booking-marketplace">
					<div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
						<ChannelIcon channelId={item.channel_id} />
						<span>{item.channel}</span>
					</div>
				</td>
			)}
			{columns[dictionary.experience]?.visible && (
				<td data-testid="booking-experience-title-slot">
					<div className='truncate booking-experience-title' title={item.experience.title}>{item.experience.title}</div>
				</td>
			)}
			{columns[dictionary.start_time]?.visible && (
				<td data-testid="booking-experience-title-slot">
					<div className='truncate booking-experience-title' title={DateFormatHelper.monthYearTimeFormat(item.slot.start_time)}>{DateFormatHelper.monthYearTimeFormat(item.slot.start_time)}</div>
				</td>
			)}
			{columns[dictionary.end_time]?.visible && (
				<td data-testid="booking-experience-title-slot">
					<div className='truncate booking-experience-title' title={DateFormatHelper.monthYearTimeFormat(item.slot?.end_time)}>{DateFormatHelper.monthYearTimeFormat(item.slot?.end_time)}</div>
				</td>
			)}
			{columns[dictionary.collection]?.visible && (
				item?.group ? 
				(
					<td data-testid="booking-experience-title-slot">
						<div className='truncate booking-experience-title' title={item.group.title}>{item.group.title}</div>
					</td>
				) : <td data-testid="booking-experience-title-slot">-</td>
				
			)}
			{columns[dictionary.rating]?.visible && (
				<td data-testid="booking-payment-status">
					{item.ratings}
				</td>
			)}
			{columns[dictionary.payment]?.visible && (
				<td data-testid="booking-payment-status">
					<PaymentStatusListItem status={item.payment_status.value} />
				</td>
			)}
			{columns[dictionary.amount]?.visible && (
				<td>
					<div className="booking-amount" data-testid="booking-price">
						{currencyDecorator(AmountFormatHelper.formatAmount(item.amount), item.currency)}
					</div>
				</td>
			)}
			<td>
				<div className="bookings-actions-wrapper">
					<IconButton onClickIcon={onContextClicked} activeState={isComponentVisible} styleObject={{width: '32px',height: '32px',borderRadius: '6px',display:'flex'}}>
						<img src={dots} />
					</IconButton>

					<div ref={ref} className="booking-action-menus-container">
						{isComponentVisible ? (
							<>
								<div className="booking-actions-container">
									{/*<div className='booking-action-container'
                                         onClick={(e) => {
                                             e.stopPropagation()
                                             setStatusesVisibility(!showStatuses)
                                         }}>
                                        <img src={booking}/>
                                        <div>
                                            {dictionary.status + ':' + bookingStatuses[item.status.value].text}
                                        </div>
                                        <div className='flex-filler'/>
                                        <img src={caret}/>
                                    </div>*/}
									<div
										className="booking-action-container"
										data-testid="booking-action-view"
									>
										<EyeIcon />
										<div>{dictionary.view}</div>
									</div>
									{isOffline && (
										<div
											className="booking-action-container"
											data-testid="booking-action-edit"
											onClick={(e) => {
												e.stopPropagation();
												setIsComponentVisible(false);
												onEditClicked(item);
											}}
										>
											<PencilIcon />
											<div>{dictionary.edit}</div>
										</div>
									)}
									{!(item.status.value === 'cancelled' || item.status.value === 'cancelled_provider' || moment.unix(item?.slot.start_time).valueOf() <= new Date().valueOf()) &&
										<div
											className="booking-action-container"
											data-testid="booking-action-view"
											onClick={(e) => {
												e.stopPropagation();
												onCancelClicked(item);
											}}
										>
											<RoundedCloseIcon/>
											<div>{dictionary.cancel}</div>
										</div>
									}
									{isOffline && (
										<div
											className="booking-action-container"
											data-testid="booking-action-delete"
											onClick={(e) => {
												e.stopPropagation();
												setIsComponentVisible(false);
												onDeleteClicked(item);
											}}
										>
											<TrashIcon />
											<div>{dictionary.delete}</div>
										</div>
									)}
									{/*<div className='booking-action-container' onClick={() => onDeleteClicked(item)}>
                                        <img src={bin}/>
                                        <div>
                                            {dictionary.delete}
                                        </div>
                                    </div>*/}
								</div>
								{showStatuses ? (
									<div className="booking-actions-container booking-statuses-container">
										{Object.keys(bookingStatuses).map((key) => (
											<div
												key={key}
												onClick={(e) => {
													changeBookingStatusAsync(e, key);
												}}
												className="booking-action-container"
												style={{ justifyContent: 'space-between' }}
											>
												<div>{bookingStatuses[key].text}</div>
												{item.status.value === key ? <img src={check} /> : null}
											</div>
										))}
									</div>
								) : null}
							</>
						) : null}
					</div>
				</div>
			</td>
		</tr>
	);
};

BookingItem.propTypes = {
	columns: PropTypes.object,
	item: PropTypes.object,
	onDeleteClicked: PropTypes.func,
	onBookingClicked: PropTypes.func,
	onCancelClicked: PropTypes.func,
	onEditClicked: PropTypes.func
};

export default BookingItem;
